export default {
  //Norge / Norsk no NO
LandingPage: {
  intro_sub:
    'Gi kartongen nytt liv',
  title: 'Samsungs kartonger',
  sequence1_1: 'Finn nye bruksområder for kartongen',
  sequence1_2:
    'Lag nye produkter av kartongen til TV-en. Bla nedover for å se hvordan du gjør det.',
  sequence2_1: 'La oss presentere: Samsungs nye kartonger',
  sequence2_2:
    'En TV-kartong er utformet slik at den kan «upcycles», altså til å lage nye produkter av kartongen.',
  sequence3_1: 'Følg punktene på kartongen',
  sequence3_2:
    'Klipp i kartongen etter instruksjonene, og sett sammen til et nytt produkt!',
  sequence4_1: 'Velg hvilket produkt du vil lage',
  sequence4_2:
    'Bla nedover, og velg hvilken TV-modell du har. Velg deretter mellom de ulike designvalgene, og lag et helt nytt produkt av kartongen.',
  selectBox: 'Velg din TV',
  moreActivity:
    "Mer informasjon om Samsungs aktiviteter",    
  OLED: 'OLED',
  QLED8K: 'QLED', //update
  UHD: 'Crstal UHD', //update
  theFrame: 'The Frame', //update
  theSerif: 'The Serif', //update
  theSero: 'The Sero', //update
  theTerrace: 'The Terrace', //update
  thePremiere: 'The Premiere', //update
  Monitors: 'Monitors', //update
  OdysseyArk:"Odyssey Ark",
  QSoundbar: 'Q Soundbar', //update
  Soundbar: 'Soundbar', //update
  SoundbarSet01:'Soundbar Set 1',
  SoundbarSet02:'Soundbar Set 2',
  TheTerraceSoundbar:'The Terrace Soundbar',
  Soundtower:'Sound Tower',
  BespokeJet: 'BESPOKE Jet\n (Jet)',
  BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
  BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
  BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
  BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
  BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
  BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
  BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
  Qooker:'Qooker',
  BespokeSlim:'BESPOKE Slim',
  TheFreeStyle:"The Freestyle",
  BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
  JetCleanStation:"Jet&\nClean Station™",
  JetCleanStation2:"Jet&Clean Station™",
  BlueSky:"BlueSky \n5500",
  BlueSky3000:"BlueSky \n3000",
  BlueSky3100:"BlueSky \n3100",
  BlueSky5000:"BlueSky \n5000",
  BespokeJetbot:"BESPOKE\n Jet Bot",
  BespokeJetbot2:"BESPOKE Jet Bot",
  BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
  BespokeJetbotPlus2:"BESPOKE Jet Bot+",
  BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
  BespokeJetbotAI2:"BESPOKE Jet Bot AI",
  Canister01:"Canister \n01",
  Canister02:"Canister \n02",
  Jupiter:"Vacuum \nCleaner",
  ref_cube:"BESPOKE Cube",
  WaterPurifier:"Water Purifier",
  LATIN:"LATIN",
  LATIN10:"LATIN10",
  MIRROR:"MIRROR",
  MW5100J:"MW5100J",
  STENA:"STENA",
  // moreActivityLink:
  //   'https://www.samsung.com/us/sustainability/overview/',
  moreActivityLink:'https://www.samsung.com/no/aboutsamsung/sustainability/strategy/',
  footer: `
  Copyright© 2019-2021 Samsung. Kaikki oikeudet pidätetään.`,
},
ProductPage: {
  selectDesign: 'Velg hvilket produkt du vil lage',
  selectDesignDezeen: 'Samsung X Dezeen', //update
  selectDesignSoccer: 'Samsung X Football', 
  tvConsole: 'TV-konsoll',
  StorageBox: 'Oppbevaringseske',
  MagazineRack: 'Bladstativ',
  CatHouse: 'Kattehus',
  CatTunnel: 'Kattetunnel',
  BookShelf: 'Bokhylle',
  DeskShelf: 'Skrivebordshylle',
  BlackRhino: 'Utrydningstruede\n dyr\n Spissneshorn', //update
  PolarBear: 'Utrydningstruede\n dyr\n Isbjørn', //update
  SeaTurtle: 'Utrydningstruede\n dyr\n Skilpadde', //update
  TheRider: 'Gyngehest', //update
  Kibe: 'Kibe', //update
  Tessellate: 'Hylle', //update
  Twist: 'Twist-eske', //update
  AlexCouchArmTable: 'Alex bord til armstøtte', //update
  BlastOffClubHouse: 'Raketthus', //update
  KinokoTable: 'Kinoko-bord', //update
  Magnuss: 'Magnuss oppbevaringshylle', //update
  GIO: 'Krukke', //update
  PostCardPlanter: 'Postkortstativ', //update
  SneakerRack: 'Skohylle', //update
  TheSoban: 'Kokebokstativ', //update
  ToolBox: 'Verktøykasse', //update
  DeskStationary: 'Skrivebordstativ',
  CoinBank: 'Sparegris',
  MobileScanner:'Stativ til skanning med mobil',
  TabletScanner:'Stativ til skanning med nettbrett',
  PetStairs:'kjæledyr trapper',
  PetFurniture:'Pet Friendly Furniture',
  ShoeRackA:'Shoe Rack_A',
  ShoeRackB:'Shoe Rack_B',
  WineRackDog:'Wine Rack Dog',
  WineRack:'Wine Rack',
  mins: 'minutter',
  all:'Alle',
  in: 'på',
  inOnly: 'på bare',
  allBoxSize: 'Alle eskestørrelser',
  soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
},
DetailGuidePage: {
  1:'1',
  2:'2',
  3:'3',
  instructions: 'instruksjoner',
  prepare: 'Gjør klar kartongen',
  LetsDesign: "La oss designe",
  drawParts: 'Tegn delene på kartongen',
  note1: 'Merk at grafisk posisjon kan variere avhengig av land og størrelse',
  note2: 'Tegn først hele tegningen for å sikre at den får plass på kartongen',
  numberSpace: 'nummer = avstand mellom prikker',
  diagonal: 'diagonalt',
  LEFT: 'VENSTRE',
  RIGHT: 'HØYRE',
  TOP: 'TOPPEN',
  TOP1: 'TOPPEN 1',
  TOP2: 'TOPPEN 2',
  BACK: 'BAK',
  MIDDLE: 'MIDTEN',
  MIDDLE2: 'MIDTEN 2',
  BOTTOM: 'BUNNEN',
  FRONT: 'FREM',
  SIDE: 'SIDEN',
  secondSIDE: 'ANDRE SIDEN',
  secondSIDE1: 'ANDRE SIDEN 1',
  secondSIDE2: 'ANDRE SIDEN 2',
  LEG: 'BEN', //update
  JOINT: 'SKARV', //update
  FACE: 'ANSIKT', //update
  DRAWERBOTTOM: 'ESKENS BUNN', //update
  DRAWERSIDE: 'EKSENS SIDE', //update
  NOSE: 'NESE', //update
  HANDLE: 'HÅNDTAK', //update
  BOTTOMSIDE: 'BUNNSIDEN', //update
  TOPSIDE: 'TOPPSIDEN', //update
  WING: 'VINGE', //update
  cutAndAssemble: "På tide å klippe og montere",
  beCareful: 'Vær forsiktig så du ikke kutter deg når du klipper',
  cutOutParts: 'Klipp ut deler',
  assemble: 'Sett sammen',
  Assemblyguide: 'Monteringsveiledning', //update
  fold: 'Eksempel på bretting',
  foldGuide: 'Bruk kanten på produktet når du bretter kartongen',
  foldGuideDezeen:
    'Trykk noen ganger på den stiplede linjen på kartongen, slik at det blir lettere å brette kartongen', //update
  glue: 'Påfør lim eller teip jevnt på overflaten', //update
  cable: 'Bruk for eksempel kabelbånd til å feste delene sammen', //update
  done: 'Ferdig!',
  goBack: 'Tilbake til hovedmenyen',
},
CautionPage: {
  CAUTION: 'ADVARSEL',
  needItem: 'Du trenger disse gjenstandene',
  children: 'Barn må være sammen med en voksen',
  mat:
    'Beskytt gulvet for å unngå riper',
  doNotPutHeavyThing:
    'Ikke stå eller sitt på møblene, og ikke legg tunge ting på dem',
  doNotThrow:
    'Ikke kast eller spark møblene mot noe eller noen, inkludert mennesker og dyr',
  stayAwayFlame: 'Holdes unna flammer og ild',
  stayAwayWater: 'Holdes unna vann og fuktighet',
  mayDamaged: '*) TV-kartongen kan skades under levering',
  companyDoestResponsible:
    '*) Selskapet påtar seg ikke ansvar for ulykker eller skader ved slikt arbeid',
  cannotBeReturned:
    '*) Produkter med skadede kartonger kan ikke returneres på grunn av kvaliteten',
  understand: 'OK, jeg forstår',
},
PrivacyPolicy: {
  title: 'Personvernpolicy',
},
GoingGreen: {
  visual: {
    title: 'Våre innovasjoner innen kartonger',
    text1:
      'Vi streber etter å bruke mindre papir og blekk i de fleste av våre TV-kartonger sammenlignet med våre tidligere kartonger. ',
    text2:'',
    text2_special:
      '(*) Ovennevnte gjelder ikke for visse modeller, inkludert Lifestyle-TV)',
    text3: 'Velg en knapp nedenfor for å lese mer',
  },
  greenIn: {
    title: 'Nye kartonginnovasjoner',
    subtitle1: 'Søk etter produktinformasjon',
    subtitle2: 'Upcycling av kartonger',
    desc: 'Søk på modellnavn for å lese mer',
    descM: '*) Ta bilde av TV-modellnummeret',
    guide: 'modellnavn',
    button: 'Ta bilde',
    button2: 'Gå til Lag produkter',
    product_info: 'Produktinformasjon',
  },
  search: {
    guide: 'Søk...',
    noResult: 'Ingen resultater',
    more: 'MER',
    search: 'Søk',
    retake: 'Søk på nytt',
    result: 'Resultat',
  },
  photo: {
    guide1: 'Plasser TV-modellnavnet i kartongen',
    guide2: '(f.eks. Q800A, UT7000, RU710)',
  },
},
searchCountrySelect: 'Velg land for å søke'
};
